import { useLang } from "@/contexts/LanguageContext";
import { Link } from "react-router-dom";

export function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t bg-muted/30 mt-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-3">
          <img
            src="/hood-icon.png"
            alt={t("app.name")}
            className="size-12 rounded-xl object-cover shadow"
          />
          <div>
            <div className="font-black text-lg">{t("app.name")}</div>
            <div className="text-sm text-muted-foreground max-w-md">
              {t("footer.tagline")}
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:items-end gap-1 text-xs text-muted-foreground">
          <div className="flex items-center gap-3">
            <Link to="/privacy" className="hover:text-primary transition-colors font-semibold" data-testid="footer-privacy-link">
              الخصوصية
            </Link>
            <span>·</span>
            <Link to="/terms" className="hover:text-primary transition-colors font-semibold" data-testid="footer-terms-link">
              الشروط
            </Link>
            <span>·</span>
            <Link to="/data-deletion" className="hover:text-primary transition-colors font-semibold" data-testid="footer-data-deletion-link">
              حذف البيانات
            </Link>
          </div>
          <div>© {new Date().getFullYear()} {t("app.name")} · {t("footer.rights")}</div>
        </div>
      </div>
    </footer>
  );
}
